let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("co6o3")).then(() => parcelRequire('3xLyL'));